import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const Style = withTheme(styled(Box)`
  background-color: ${(props: any) => props.theme.palette.info.light};
  ${(props: any) =>
    props.backgroundImage
      ? `
    background-image: linear-gradient(
      to left, transparent, ${props.theme.palette.info.light}),
      url(${props.backgroundImage}),
      linear-gradient(
        to left,
        ${props.theme.palette.info.light},
        ${props.theme.palette.info.light}
      );
    background-position: right center, right center, left center;
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-size: 800px 100%, 800px 99.5%, 100% 100%;

    ${props.theme.breakpoints.down('lg')} {
      background-image: linear-gradient(
          to left,
          ${props.theme.palette.info.light},
          ${props.theme.palette.info.light}
        ),
        linear-gradient(to left, transparent 10%, ${props.theme.palette.info.light} 95%),
        url(${props.backgroundImage});
      background-position: left center, right center, right center;
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-size: 40% 100%, 61% 100%, 800px 100%;
    }

    ${props.theme.breakpoints.down('md')} {
      background-image: linear-gradient(
          to left,
          ${props.theme.palette.info.light},
          ${props.theme.palette.info.light}
        ),
        linear-gradient(to left, transparent 10%, ${props.theme.palette.info.light} 95%),
        url(${props.backgroundImage});
      background-position: left center, right center, right -140px center;
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-size: 40% 100%, 61% 100%, 800px 100%;
    }

    ${props.theme.breakpoints.down('sm')} {
      background-image: linear-gradient(
          to left,
          ${props.theme.palette.info.light},
          ${props.theme.palette.info.light}
        ),
        linear-gradient(to left, transparent, ${props.theme.palette.info.light}),
        url(${props.backgroundImage});
      background-position: left center, right center, right -140px center;
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-size: 50% 100%, 50% 100%, 800px 100%;
    }
  `
      : ''}

  height: ${(props: any) => props.contentHeight};
  position: relative;
`);

export const HeaderContainer = withTheme(styled(Box)`
  max-width: 1180px;

  ${(props: any) =>
    props.isSupportLargeScreen &&
    `
    @media (max-width: 1999px) and (min-width: 1701px) {
      max-width: 1460px;
    }
    @media (min-width: 2000px) {
      max-width: 1750px;
    }
  `}

  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  & .MuiBreadcrumbs-li * {
    font-size: 18px;
  }
  .title {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 36px;
  }
  .description {
    margin-top: 8px;
    line-height: 28px;
    font-family: 'Lanna';
    font-size: 22px;
    color: ${(props: any) => props.theme.palette.secondary.light};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  ${(props: any) =>
    props.backgroundImage &&
    `
      .description  {
        max-width: 600px;
      }
    `}

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .title {
      font-size: 24px;
      -webkit-line-clamp: 2;
    }
    ${(props: any) =>
    props.backgroundImage &&
      `
      .description  {
        max-width: 480px;
      }
    `}
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    ${(props: any) =>
    props.backgroundImage &&
      `
      .description  {
        max-width: 228px;
        font-size: 16px;
        line-height: 22px;
      }
    `}
  }

  .breadcrumb-link {
    color: ${(props: any) => props.theme.palette.primary.main};
    font-family: 'Heavent';
    font-size: 18px;
    padding: 0;
    font-weight: bold;
    border-radius: 4px;
  }
`);

export const SearchNotFoundStyle = withTheme(styled(Box)`
  background: white;
  height: 80px;
  a:hover {
    -webkit-text-decoration: none;
    text-decoration: none;
    background-color: rgba(0, 83, 42, 0.04);
  }
`);
